import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch } from 'store';
import { changeTheme, LayoutState } from 'store/layoutSlice';

import Button from 'layout/atoms/Button';

import { ReactComponent as MoonIcon } from 'assets/icons/moon.svg';
import { ReactComponent as SunIcon } from 'assets/icons/sun.svg';

const ThemeToggle = () => {
    const dispatch = useDispatch<AppDispatch>();
    const layoutState: LayoutState = useSelector((state: any) => state.layout);

    const handleChange = () => {
        const newTheme = layoutState.theme === 'light' ? 'dark' : 'light';
        localStorage.setItem('hustleTheme', newTheme);
        dispatch(changeTheme());

        if (newTheme === 'dark') {
            document.body.classList.add('dark-theme');
            document.documentElement.style.backgroundColor = '#191919';
            document.body.style.backgroundColor = '#191919';
        } else {
            document.body.classList.remove('dark-theme');
            document.documentElement.style.backgroundColor = '';
            document.body.style.backgroundColor = '';
        }
    };

    return (
        <Button size="m" align="left" onClick={handleChange} keepDropdownOpen>
            {layoutState.theme === 'light' ? <MoonIcon /> : <SunIcon />}
            <span>
                {layoutState.theme === 'light' ? 'Dark theme' : 'Light theme'}
            </span>
        </Button>
    );
};

export default ThemeToggle;
